import { Roles } from '../enums/Roles';

export const GetAccountInfo = () => {
  let account: any = null;
  try {
    let accountKey = JSON.parse('[' + sessionStorage.getItem('msal.account.keys') + ']');
    account = JSON.parse('[' + sessionStorage.getItem(accountKey[0]) + ']');
  } catch (error) {
    console.error('Could not fetch signed in user info');
  }
  let user = { userName: account[0].username, name: account[0].name };
  return user;
};

export const GetUserRoles = async () => {
  let roles: any;

  try {
    let sessionRoles = sessionStorage.getItem('roles');
    if (sessionRoles) {
      roles = JSON.parse(sessionRoles);
      return roles;
    }
  } catch (error) {
    console.error('Could not fetch users roles');
    return roles;
  }
};

export const CheckIfAdminUser = (): boolean => {
  let roles: any;
  let isAdmin = false;
  try {
    let sessionRoles = sessionStorage.getItem('roles');
    if (sessionRoles) {
      roles = JSON.parse(sessionRoles);
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === Roles.Admin) {
          isAdmin = true;
          break;
        }
      }
    }
  } catch (error) {
    console.error('Could not fetch users roles');
  }

  return isAdmin;
};
